<template lang="pug">
  span.ma-0.pa-0.iconContainer
    v-icon(small :color="iconColor") fas fa-circle


</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'

@Component({
  components: {

  },
})
export default class BankTransactionStatusCellRenderer extends Vue {

  get iconColor (): string {
    // @ts-ignore
    switch (this.params.data.transaction.status) {
      case 'done': return 'green'
      case 'to_wallet': return 'green'
      case 'not_processed': return 'orange'
      case 'ignored': return 'grey'
      case 'unknown': return 'grey'
      case 'error': return 'red'

      default: return 'transparent'
    }
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>
.iconContainer
  text-align-center
</style>
